/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Logo_AltInputs */

const en_fc_logo_alt = /** @type {(inputs: Fc_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft guide logo`)
};

/**
* | output |
* | --- |
* | "FilmCraft guide logo" |
*
* @param {Fc_Logo_AltInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_logo_alt = /** @type {((inputs?: Fc_Logo_AltInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Logo_AltInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_logo_alt(inputs)
});
export { fc_logo_alt as "fc.logo_alt" }